import Vue from 'vue'
import Router from 'vue-router'
import Managerlogin from "@/components/utadmin/page/ManagerLogin.vue";
Vue.use(Router)

const originalPush = Router.prototype.push
//修改原型对象中的push方法 //解决vue路由重复导航错误
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    routes: [
        {
            path: '/',
            redirect: '/security_advisory'
        },
        {
            path: '/utmanagerloginmanagerlogin',
            name: 'Managerlogin',
            component: Managerlogin
        },
        {
            path: '/utadmin/',
            component: () => import('@/components/utadmin/common/Home.vue'),
            meta: { title: 'ManagerPage' },
            children: [
                {
                    name: "manager",
                    path: '/manager',
                    component: () => import('@/components/utadmin/page/user/manager.vue'),
                    meta: { title: 'manager' }
                },
                {
                    name: "systemlog",
                    path: '/systemlog',
                    component: () => import('@/components/utadmin/page/system/SystemLog.vue'),
                    meta: { title: 'systemlog' }
                },
                {
                    name: "security_advisory_manage",
                    path: '/security_advisory_manage',
                    component: () => import('@/components/utadmin/page/security_advisory/SecurityAdivisoryManage.vue'),
                    meta: { title: 'manager' }
                },
                {
                    name: "index_manage",
                    path: '/index_manage',
                    component: () => import('@/components/utadmin/page/index/Index.vue'),
                    meta: { title: 'index_manage' }
                }
            ]
        },
        {
            path: '/uthome/',
            component: () => import('@/components/uthome/common/Home.vue'),
            meta: { title: 'HomePage' },
            children: [
                {
                    name: "security_advisory",
                    path: '/security_advisory',
                    component: () => import('@/components/uthome/page/security_advisory/SecurityAdivisoryList.vue'),
                    meta: { title: 'security_advisory' }
                },
                {
                    name: "security_advisory_detail",
                    path: '/security_advisory_detail',
                    component: () => import('@/components/uthome/page/security_advisory/SecurityAdivisoryDetail.vue'),
                    meta: { title: 'security_advisory_detail' }
                },
            ]
        },
        // 404 页面
        {
            path: "/404",
            name: "NotFound",
            component: () => import("@/components/404.vue"),
            hidden: true,
            meta: { title: "404" },
        },
        // 当什么都没有匹配到的时候，重定向页面到 404 页面
        { path: "/:pathMatch(.*)", redirect: "/404", name: "notMatch", hidden: true },
    ]
})

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
    if (to.path === '/' || to.path === '/security_advisory') {
        if (!to.query.t) {
            next({
                path: to.path,
                query: {
                    ...to.query,
                    t: Date.now()
                }
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;